// Parallax effect on hero scroll
(function(){
  'use strict';
  var hero = document.querySelector('[data-nuvy-hero]');
  if (!hero) return;
  var media = hero.querySelector('[data-nuvy-hero-media]');
  if (!media) return;
  var img = media.querySelector('.nuvy-hero__img--mobile, .nuvy-hero__img--desktop, .nuvy-hero__video');
  if (!img) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function updateParallax() {
    var imgs = hero.querySelectorAll('.nuvy-hero__img, .nuvy-hero__video');
    var rect = hero.getBoundingClientRect();
    var heroHeight = hero.offsetHeight;
    if (rect.bottom < 0 || rect.top > window.innerHeight) { ticking = false; return; }
    var scrolled = Math.min(Math.max(-rect.top, 0), heroHeight);
    var translateY = scrolled * 0.35;
    imgs.forEach(function(el){ el.style.transform = 'translateY(' + translateY + 'px)'; });
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { window.requestAnimationFrame(updateParallax); ticking = true; }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  updateParallax();
})();
